import * as React from 'react';

import {FileComponent} from "./Component";
import {RecursiveFolderTree} from "./Component";
import {HasMemoryParams, HasFile, HasFilesFolders, HasFiles, FolderHierarchyRendererProps} from "./Types";

interface FileWidgetProps extends HasMemoryParams, HasFile {}

export class FileWidget extends React.Component<FileWidgetProps, {}> {
	render() {
		return <div className="memory-module">
			<FileComponent file={this.props.file} />
		</div>
	}

}

interface FilesFoldersWidgetProps extends HasMemoryParams, HasFilesFolders {}

export class FilesFoldersWidget extends React.Component<FilesFoldersWidgetProps, {}> {
	render() {
		return <div className="memory-module items">
			<FilesList files={this.props.files}/>
			<FolderHierarchyRenderer folders={this.props.folders} directoryIconPath={this.props.memoryParams.directoryIconPath} />
		</div>
	}
}

class FilesList extends React.Component<HasFiles, {}> {
	render() {
		if (this.props.files.length === 0) {
			return null;
		}

		return <ul className="file-list item-list">
			{this.props.files.map((file) => <FileComponent key={`file-item-${file.id}`} file={file} /> )}
		</ul>
	}
}

class FolderHierarchyRenderer extends React.Component<FolderHierarchyRendererProps, {}> {
	render() {
		// No folders were selected at all, or the ones which were selected were not accessible to the current user.
		if (this.props.folders == null || this.props.folders.length == 0) {
			return null;
		}

		// Folders were selected, but due to permissions, the current user was not able to access any of its children.
		const withoutChildren = this.props.folders.find((folder) => { return folder.hierarchy == null || folder.hierarchy.length == 0; });
		if (withoutChildren != null) {
			return null;
		}

		return <ul className="category-list item-list">
			{this.props.folders.map((folder) => {
				return (
					<RecursiveFolderTree
						key={`category-tree-${folder.folderId}`}
						parentId={folder.folderId}
						directoryIconPath={this.props.directoryIconPath}
						allPotentialChildren={folder.hierarchy} />
				);
			})}
		</ul>
	}
}



// WEBPACK FOOTER //
// ./src/memory/component/Public.tsx